<template>
  <div :class="['smd-aileron', openPosition]" v-show="value"
       v-click-outside="hideContent">
    <div class="content" ref='content'>
      <slot/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'smd-aileron',
    props: {
      openPosition: String,
      value: Boolean
    },
    methods: {
      hideContent() {
        if(this.value) {
          this.$emit('input', false);
        }
      }
    }
  }
</script>

<style lang="scss">

  @import 'scss/pogs-util';

  %arrow{
    content: ' ';
    background: white;
    height: 15px;
    width: 15px;
    transform: rotate(45deg);
    position: absolute;
    z-index: 1000;
  }

  .smd-aileron {
    filter: drop-shadow(0px 0px 12px rgba(33, 33, 33, .25));
    position: absolute;
    z-index: 1002;

    & > .content {
      @extend %border-radius-normal, %hide-overflow;
      background: white;
      padding: 0;
      position: relative;
      z-index: 1003;

      .form{
        @include space-me(m);
      }
    }

    &.bottom{
      top: 48px;
      right: -10px;

      &:after{
        @extend %arrow;
        top: -7px;
        right: 28px;
      }

      &.left{
        left: 10px;
        right: unset;

        &:after{
          right: unset;
          left: 28px;
        }
      }
    }

    &.top{
      bottom: 50px;
      left: -10px;

      &:after{
        @extend %arrow;
        bottom: -7px;
        left: 28px;
      }
    }

  }

</style>